import React from 'react'

export const ServiceList = () => {
  return (
    <div>ServiceList</div>
  )
}
